
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/docs/api-vs-mcp",
      function () {
        return require("private-next-pages/docs/api-vs-mcp.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/docs/api-vs-mcp"])
      });
    }
  